import { NavLink } from 'react-router-dom'
import { Headset } from 'lucide-react'
import { FEATURES } from '@/lib/featureFlags'
import { PERMISSIONS, usePermission } from '@/lib/permissions'
import { cn } from '@/lib/utils'
import { useFeatureFlag } from '@/providers/FeatureFlagsProvider'

/**
 * Title21 Support from anywhere: one header icon (a headset, the usual mark
 * for a support desk) to the Support page, where "Report an issue" lives.
 * Only for tenants with the `support` feature and users with support.read.
 */
export function SupportHeaderLinks() {
  const enabled = useFeatureFlag(FEATURES.support)
  const { can } = usePermission()
  if (!enabled || !can(PERMISSIONS.supportRead)) return null
  return (
    <NavLink
      to='/support'
      title='Support'
      aria-label='Support'
      className={({ isActive }) =>
        cn(
          'flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground',
          isActive && 'bg-muted text-primary',
        )
      }
    >
      <Headset className='h-4 w-4' />
    </NavLink>
  )
}
